import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import Icon from '../../../Icon';
import ButtonIcon from '../../../ButtonIcon';
import SwitchPin from '../../../SwitchPin';
import ButtonNPI from '../../../ButtonNPI';
import SwitchCamera from '../../../SwitchCamera';
import SwitchMic from '../../../SwitchMic';
import { IconColors, IconSizes, IconVariants, SELF_PARTICIPANT_ID, } from '../../../../constants';
import { actions as callActions, selectors as callSelectors, helpers as callHelpers, constants as callConstants } from '../../../../../call';
import { isDoctor, isPatient } from '../../../../../call/helpers';
import { openActionsForParticipantId } from '../../../../actions';
import MoreActionsIcon from '../../../../assets/icons/more-actions.svg';
import ScreenShareIcon from '../../../../assets/icons/screenshare.svg';
import './ParticipantsListItem.scss';
const ParticipantsListItem = ({ participant, pinnedStreamId }) => {
    const dispatch = useDispatch();
    const { id, uuid, hasVideo, hasAudio } = participant;
    const isPinned = pinnedStreamId === id;
    const isScreenSharing = participant.streamType === callConstants.StreamType.Screen;
    const isSelfParticipant = SELF_PARTICIPANT_ID === id;
    const hasNpiIcon = useSelector((state) => callSelectors.hasParticipantNpiIcon(state, uuid));
    const togglePinHandle = useCallback(() => dispatch(callActions.pinStream(id)), []);
    const openActionsHandle = useCallback(() => dispatch(openActionsForParticipantId(id)), [id]);
    const participantScreenName = callHelpers.getParticipantScreenName(participant.name, participant.streamType);
    const rootClassNames = classnames({
        'ml-participants-list-item': true,
        'ml-participants-list-item--pinned': isPinned,
    });
    return (<div className={rootClassNames} onClick={togglePinHandle}>
      <div className="ml-participants-list-item__controls">
        {isPinned && !isScreenSharing
            ? <div className="ml-participants-list-item__control ml-participants-list-item__control--clickable">
                <SwitchPin participantId={id}/>
              </div>
            : null}
        {isScreenSharing
            ? <div className="ml-participants-list-item__control ml-participants-list-item__control--clickable">
                <Icon size={IconSizes.Medium} variant={IconVariants.Plain} color={IconColors.Transparent}>
                  <ScreenShareIcon />
                </Icon>
              </div>
            : null}
      </div>
      <div className="ml-participants-list-item__title">
        {isSelfParticipant
            ? <FormattedMessage id="video-chat.mobile.self-participant"/>
            : participantScreenName}
      </div>
      <div className="ml-participants-list-item__controls">
        {hasNpiIcon &&
            <div className="ml-participants-list-item__control">
            <ButtonNPI size={IconSizes.Medium} variant={IconVariants.Plain} disabled={true}/>
          </div>}
        {!hasVideo &&
            <div className="ml-participants-list-item__control">
            <SwitchCamera isActive={hasVideo} size={IconSizes.Medium} variant={IconVariants.Plain}/>
          </div>}
        <div className="ml-participants-list-item__control ">
          <SwitchMic isActive={hasAudio} size={IconSizes.Medium} variant={IconVariants.Plain} disabled={isPatient()}/>
        </div>
        {isDoctor() && !isSelfParticipant &&
            <div className="ml-participants-list-item__control ml-participants-list-item__control--clickable">
            <ButtonIcon clickHandle={openActionsHandle} hasPropagation={false}>
              <MoreActionsIcon />
            </ButtonIcon>
          </div>}
      </div>
    </div>);
};
export default ParticipantsListItem;
